import { C } from '../constants';
import InfoTip from './InfoTip';

export default function KpiCard({ label, value, sub, fakeCnt, color, tip, trend, statusRow }) {
  let trendEl = null;
  if (trend != null) {
    const up = trend >= 0;
    const pct = Math.min(Math.abs(trend), 999);
    trendEl = (
      <span style={{
        display: "inline-flex", alignItems: "center", gap: 3,
        background: up ? "rgba(52,211,153,.13)" : "rgba(244,114,182,.13)",
        color: up ? C.green : C.pink,
        border: `1px solid ${up ? C.green : C.pink}25`,
        padding: "2px 9px", borderRadius: 20, fontSize: 11, fontWeight: 700,
      }}>
        {up ? "↑" : "↓"} {pct.toFixed(1)}%
      </span>
    );
  }

  return (
    <div style={{
      background: `linear-gradient(145deg, ${C.bg2} 0%, ${C.bg1} 100%)`,
      border: `1px solid ${color}20`,
      borderLeft: `3px solid ${color}`,
      borderRadius: 14,
      padding: "22px 22px",
      display: "flex",
      flexDirection: "column",
      position: "relative",
      overflow: "hidden",
      boxShadow: `0 4px 24px rgba(0,0,0,.45), 0 0 60px ${color}07`,
    }}>
      <div style={{
        position: "absolute", right: -24, top: -24, width: 110, height: 110,
        background: `radial-gradient(circle, ${color}14 0%, transparent 68%)`,
        pointerEvents: "none",
      }} />

      <div style={{
        fontSize: 10, color: C.text3, textTransform: "uppercase",
        letterSpacing: "1px", marginBottom: 10,
        display: "flex", alignItems: "center", gap: 5, fontWeight: 700,
      }}>
        {label}{tip && <InfoTip text={tip} />}
      </div>

      <div style={{ display: "flex", alignItems: "baseline", gap: 8, flexWrap: "wrap" }}>
        <div style={{
          fontSize: 40, fontWeight: 800, color: C.text1,
          letterSpacing: "-1px", lineHeight: 1,
          fontVariantNumeric: "tabular-nums",
        }}>
          {value}
        </div>
        {fakeCnt > 0 && (
          <div style={{ fontSize: 13, color: C.yellow, fontWeight: 600, opacity: 0.85 }}>
            ({fakeCnt} викупів)
          </div>
        )}
      </div>

      {sub && (
        <div style={{ marginTop: 7, fontSize: 11.5, color: C.text3 }}>
          {sub}
        </div>
      )}

      {trendEl && (
        <div style={{ marginTop: 10 }}>{trendEl}</div>
      )}

      {statusRow && statusRow.length > 0 && (
        <div style={{
          marginTop: 10, display: "flex", gap: 12, flexWrap: "wrap",
          borderTop: `1px solid ${C.border}`, paddingTop: 8,
        }}>
          {statusRow.map((s, i) => (
            <span key={i} style={{
              fontSize: 11.5, color: s.color, fontWeight: 700,
              display: "flex", alignItems: "center", gap: 3,
            }}>
              <span style={{ opacity: 0.65 }}>{s.icon}</span>
              {(s.value || 0).toLocaleString()}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
